module.exports = __webpack_public_path__ + "static/media/1417.00f887df.wav";